import type { Root, Text, HTML } from "mdast";
import { visit } from "unist-util-visit";

/**
 * Rewrites `<track>` / `</track>` to `<vlm-track>` / `</vlm-track>`.
 *
 * `<track>` is an HTML void element — parse5 self-closes it and promotes
 * children to siblings, breaking the rehype annotation processor's
 * `insideTrack` context. Renaming to a hyphenated custom-element tag
 * sidesteps the void rule entirely.
 */
export const remarkTrackAlias = () => {
  function transformer(tree: Root) {
    visit(tree, (node, index, parent) => {
      if (!parent) return;
      if (node.type === "code" || node.type === "inlineCode") return;

      if (node.type === "text" || node.type === "html") {
        const original = (node as Text | HTML).value;
        const replaced = original.replace(/<\s*(\/?)\s*track(?=[\s>\/])/gi, (_, slash: string) => `<${slash}vlm-track`);

        if (replaced !== original) {
          if (node.type === "text") {
            // Promote text → html so rehype-raw re-parses the renamed tag.
            parent.children[index!] = { type: "html", value: replaced };
          } else {
            (node as HTML).value = replaced;
          }
        }
      }
    });
  }

  return transformer;
};
